import { store } from 'redux/store';

import { checkClassRangeOverlaps } from 'modules/partners/api/checkClassRangeOverlaps';
import { CustomRange } from '../types/CustomRange';

type ConflictRange = { from: number; to: number };

export type OverlapResult = {
  overlaps: ConflictRange[];
  overlapCount: number;
};

type CheckOverlapsProps = {
  holdingClassId?: string;
  reassignedRanges: CustomRange[];
  savedRanges?: CustomRange[];
};

export const checkOverlaps = async ({
  holdingClassId,
  reassignedRanges,
  savedRanges = [],
}: CheckOverlapsProps): Promise<OverlapResult> => {
  const allReassigned = [...savedRanges, ...reassignedRanges];

  const selfConflictKeys = new Set<string>();

  reassignedRanges.forEach((a) => {
    allReassigned.forEach((b) => {
      if (b.key !== a.key && a.newFrom! <= b.newTo! && b.newFrom! <= a.newTo!) {
        selfConflictKeys.add(a.key);
        selfConflictKeys.add(b.key);
      }
    });
  });

  const selfConflicts: ConflictRange[] = allReassigned
    .filter((r) => selfConflictKeys.has(r.key))
    .map((r) => ({ from: r.newFrom!, to: r.newTo! }));

  const result = await store.dispatch(
    checkClassRangeOverlaps({
      holdingClassId,
      ranges: reassignedRanges.map((r) => ({ from: r.newFrom!, to: r.newTo! })),
      excludeKeys: allReassigned.map((r) => ({ from: r.from, to: r.to })),
    })
  );

  const originalConflicts: ConflictRange[] = result?.overlaps || [];
  const serverCount: number = result?.overlapCount || 0;

  return {
    overlaps: [...selfConflicts, ...originalConflicts],
    overlapCount: selfConflicts.length + serverCount,
  };
};
